import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import PageCard from 'Component/PageCard';
import { PageCardPropsType } from 'Type/CMS.type';

import './PageRelatedList.style';

/** @namespace PeggysagePwa/Component/PageRelatedList/Component */
export class PageRelatedListComponent extends PureComponent {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
        pages: PropTypes.arrayOf(PageCardPropsType).isRequired,
        linkLabel: PropTypes.string.isRequired,
        isHorizontallyDisplayedOnMobile: PropTypes.bool.isRequired,
        listRef: PropTypes.oneOfType([
            // Either a function
            PropTypes.func,
            // Or the instance of a DOM native element (see the note about SSR)
            PropTypes.shape({ current: PropTypes.instanceOf(Element) })
        ]).isRequired
    };

    renderTitle() {
        const { title } = this.props;

        if (title === '') {
            return null;
        }

        return (
            <h2 block="PageRelatedList" elem="Title">
                { title }
            </h2>
        );
    }

    renderContentItem(child, key) {
        const { linkLabel, isHorizontallyDisplayedOnMobile } = this.props;

        return (
            <li block="PageRelatedList" elem="Item" key={ key }>
                <PageCard
                  page={ child }
                  linkLabel={ linkLabel }
                  isHorizontallyDisplayedOnMobile={ isHorizontallyDisplayedOnMobile }
                />
            </li>
        );
    }

    renderContent() {
        const {
            listRef, pages, isMobile, isHorizontallyDisplayedOnMobile
        } = this.props;

        return (
            <div block="PageRelatedList" elem="Content" ref={ listRef }>
                <ul
                  block="PageRelatedList"
                  elem="Items"
                  mods={ { horizontal: isMobile && isHorizontallyDisplayedOnMobile } }
                >
                    { pages.map(this.renderContentItem.bind(this)) }
                </ul>
            </div>
        );
    }

    render() {
        const { pages } = this.props;

        if (!pages || !pages.length) {
            return null;
        }

        return (
            <div block="PageRelatedList">
                { this.renderTitle() }
                { this.renderContent() }
            </div>
        );
    }
}

export default PageRelatedListComponent;
